import { FieldError } from "./FieldError";
export const ClientTextArea = ({
  id,
  placeholder,
  value = '',
  type = 'text',
  disabled,
  rows = 5,
  error = false,
  errorText = 'This field is required',
  update = () => {},
  additionalClass = '',
  label = '',
  ...otherProps
}) => {
  const onChange = ({
    value
  }) => {
    update(value);
  };
  return <div className={`foundry--input-fields user-form--input ${error ? 'foundry--field-error' : ''}`}>
      <textarea id={id} className={`input-fields__textarea ${additionalClass} ${error ? 'invalid' : ''}`} type={type} rows={rows} disabled={disabled} value={value || ''} placeholder={placeholder} onChange={({
      target = {
        value: ''
      }
    }) => onChange(target)} {...otherProps}></textarea>
      <label className="input-fields__label" htmlFor={id}>
        {label}
      </label>
      {error && <FieldError errorText={errorText} />}
    </div>;
};